/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_JBP_EXECUTION_BY_STORE_EXPORT = gql`
  query GetJBPExecutionByStoreExport($input: JBPReportInput!) {
    jbpExecutionByStoreExport(input: $input) {
      results {
        id
        name
        state
        combinedCompliance
        coldVaultIssues
        auditQuestionIssues
        planName
        auditorFirstName
        auditorLastName
        auditStartTime
        auditEndTime
      }
    }
  }
`
